import { render, staticRenderFns } from "./PreferenceForm.vue?vue&type=template&id=29c9b511"
import script from "./PreferenceForm.vue?vue&type=script&lang=js"
export * from "./PreferenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports